import { AUTH_CONSTANTS } from '../constants/auth.constants';

export async function exportUserData(username: string): Promise<void> {
  const token = localStorage.getItem(AUTH_CONSTANTS.JWT_TOKEN);
  const res = await fetch('/export/data', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Export failed (${res.status})`);
  const blob = await res.blob();
  const filename = `trillirivos-data-${username}-${new Date().toISOString().slice(0, 10)}.zip`;

  const picker = (
    window as unknown as {
      showSaveFilePicker?: (o: unknown) => Promise<{
        createWritable: () => Promise<{
          write: (b: Blob) => Promise<void>;
          close: () => Promise<void>;
        }>;
      }>;
    }
  ).showSaveFilePicker;

  if (typeof picker === 'function') {
    const handle = await picker({
      suggestedName: filename,
      types: [
        { description: 'ZIP archive', accept: { 'application/zip': ['.zip'] } },
      ],
    });
    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();
    return;
  }

  // Fallback: anchor download to the default folder.
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
